export default "__VITE_ASSET__CPNdt6fO__"